'use client';
import { createContext, useContext } from 'react';

const AccordionContext = createContext(void 0);
AccordionContext.displayName = 'AccordionContext';
function useAccordionContext() {
    return useContext(AccordionContext);
}

export { AccordionContext, useAccordionContext };
